import type { Deck } from '@/framework/types';
import { slides } from './slides';

const deck: Deck = {
  slug: 'ai-conference-booth',
  category: 'booth-decks',
  title: 'Orca — The AI Conference booth loop',
  speaker: 'StreamNative',
  description:
    'Unattended 18-frame loop for the 40" booth monitor, about three minutes: live governed context from the StreamNative Data Platform, then Orca for running agents on it. Press P or open with ?autoplay.',
  date: '2026-09-30',
  context: 'The AI Conference · Pier 48, San Francisco · 29 Sep – 1 Oct 2026',
  visibility: 'public',
  // Kiosk cadence, and the fallback for any frame that does not set its own
  // `holdMs`. Long enough to read a diagram, short enough that someone walking
  // past sees the story move. The workflow frame holds 12s and the closing ask
  // 15s — see slides.tsx.
  autoplayMs: 10000,
  slides,
};

export default deck;
